import { render } from "./BillFocReport.vue?vue&type=template&id=45b8d422&scoped=true"
import script from "./BillFocReport.vue?vue&type=script&lang=js"
export * from "./BillFocReport.vue?vue&type=script&lang=js"

import "./BillFocReport.vue?vue&type=style&index=0&id=45b8d422&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b8d422"]])

export default __exports__